const ZoneReportingNavLinks = {
  ZONE_REPORTING_ROOT: '/zonereporting',
  ZONE_REPORTING_SELECTION: '/zonereporting/selection',
  ZONE_REPORTING_REPORTS: '/zonereporting/reports'
};

export default ZoneReportingNavLinks;